module.exports = __webpack_public_path__ + "img/preika_title.990b3434.png";